/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateRead.defs.js'
export { main as default } from './updateRead.defs.js'
